import { useMemo, useRef } from "react";
import useTripStore from "@/stores/tripBuilder/useTrip";
import useView from "@/stores/tripBuilder/useView";
import useAccommodationStore from "@/stores/tripBuilder/useAccommodation";
import useToraStore from "@/stores/tripBuilder/useToraStore";
import ToraContent from "@tripbuilder/cat-tora/middle/ToraContent";
import { TripDashboard } from "@tripbuilder/cat-origin/middle";
import TabsContainer, { TabType } from "@tripbuilder/tabs/TabsContainer";

import McOverview from "@tripbuilder/cat-overview/middle/mcOverview";
import McSchedule from "@tripbuilder/cat-schedule";
import McAccommodation from "@tripbuilder/cat-accommodation/middle";

const MiddleContent: React.FC = () => {
  const selectedLocation = useTripStore((state) => state.selectedLocation);
  const setViewLodging = useAccommodationStore((state) => state.setViewLodging);
  const activeTab = useView((state) => state.activeTab);
  const setActiveTab = useView((state) => state.setActiveTab);
  const setShowRecommendations = useToraStore(
    (state) => state.setShowRecommendations
  );
  const setShowAccommodations = useToraStore(
    (state) => state.setShowAccommodations
  );
  const clearContentDataByLocation = useToraStore(
    (state) => state.clearContentDataByLocation
  );
  const previousTab = useRef<string | null>(null);

  const handleTabChange = (tab: TabType) => {
    if (previousTab.current === "accommodation" && tab !== "accommodation") {
      setViewLodging(null);
    }
    if (tab === "overview") {
      setShowRecommendations(false);
      setShowAccommodations(false);
    }
    if (tab === "tora" && selectedLocation) {
      setShowRecommendations(false);
      setShowAccommodations(false);
      clearContentDataByLocation(selectedLocation.id);
    }
    setActiveTab(tab);
    previousTab.current = tab;
  };

  const isOrigin = useMemo(() => {
    return selectedLocation?.origin;
  }, [selectedLocation?.origin]);

  const renderTabContent = () => {
    switch (activeTab) {
      case "overview":
        return (
          <div className="w-full h-full">
            <McOverview />
          </div>
        );
      case "schedule":
        return (
          <div className="w-full h-full">
            <McSchedule />
          </div>
        );
      case "accommodation":
        return (
          <div className="w-full h-full">
            <McAccommodation />
          </div>
        );
      case "tora":
        return (
          <div className="w-full h-full">
            <ToraContent />
          </div>
        );
      default:
        return (
          <div className="w-full h-full">
            <McOverview />
          </div>
        );
    }
  };

  const originContent = (
    <div id="rhs-origin-content" className="w-full h-full">
      <TripDashboard />
    </div>
  );

  return (
    <section className="w-full h-full pl-1 py-1.5 rounded-xl flex flex-col">
      <div className="flex flex-col items-start mb-2">
        {isOrigin ? (
          originContent
        ) : (
          <>
            <div className="flex flex-row items-center w-full h-[35px] 2xl:h-[40px]">
              <h1 className="locationName text-2xl 2xl:text-3xl font-semibold text-neutral-800">
                {selectedLocation?.name}
              </h1>
              <div className="w-[7px] h-[7px] 2xl:w-[8px] 2xl:h-[8px] bg-blue-800 rounded-full translate-y-[1px] ml-2.5"></div>
              <h2 className="countryName text-2xl 2xl:text-3xl font-extralight text-neutral-500 ml-2.5">
                {selectedLocation?.address_components.country}
              </h2>
            </div>
            <TabsContainer
              activeTab={activeTab as TabType}
              handleTabChange={handleTabChange}
            />
          </>
        )}
      </div>
      <section id="core-view" className="w-full h-full relative">
        {isOrigin ? null : renderTabContent()}
      </section>
    </section>
  );
};

export default MiddleContent;
